import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {LecturesComponent} from './lectures/lectures.component';
import {RecordsComponent} from './records.component';
import {SeriesComponent} from './series/series.component';
import {SermonsRoutingModule} from './sermons-routing.module';
import {SermonsComponent} from './sermons/sermons.component';

@NgModule({
    imports: [
        SharedModule,
        SermonsRoutingModule
    ],
    declarations: [
        RecordsComponent,
        SermonsComponent,
        SeriesComponent,
        LecturesComponent
    ]
})
export class SermonsModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/sermons.module.ts